import { render, staticRenderFns } from "./CardDeta.vue?vue&type=template&id=0f8c8d64&scoped=true"
import script from "./CardDeta.vue?vue&type=script&lang=js"
export * from "./CardDeta.vue?vue&type=script&lang=js"
import style0 from "./CardDeta.vue?vue&type=style&index=0&id=0f8c8d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8c8d64",
  null
  
)

export default component.exports